<template>
  <div>
    <XVactionbar>
      <template slot="actionbuttons">
        <div id="pnlButtonBar">
          <div class="btn-group">
            <button type="button" id="btnTerug" class="btn btn-primary btn-xs" @click.prevent="btnTerug">
              <font-awesome-icon icon="chevron-left" />
              {{ translation(14941) }}
            </button>
            <button
              type="button"
              id="btnOpslaan"
              class="btn btn-primary btn-xs"
              @click.prevent="btnOpslaan"
              v-if="!this.$route.params.aandeelhouderid"
            >
              <font-awesome-icon :icon="['far', 'save']" />
              {{ translation(14942) }}
            </button>
            <button
              type="button"
              id="btnOpslaanUpdate"
              class="btn btn-primary btn-xs"
              @click.prevent="btnOpslaanUpdate"
              v-if="this.$route.params.aandeelhouderid"
            >
              <font-awesome-icon :icon="['far', 'save']" />
              {{ translation(14942) }}
            </button>
          </div>
        </div>
      </template>
    </XVactionbar>
    <div class="row">
      <div class="col-md-12">
        <span id="lblTitel" class="titel">{{ translation(14956) }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <p v-html="translation(14957)"></p>
      </div>
    </div>
    <fieldset class="margin20 margin20bottom">
      <XVbootstraprow
        :label="translation(14943)"
        :haserror="errors.has('tbxNaam')"
        :errormessage="errors.first('tbxNaam')"
        :required="true"
        class="margin20"
      >
        <XVinput
          id="tbxNaam"
          name="tbxNaam"
          v-model="aandeelhouder.tbxNaam"
          type="text"
          v-validate="'required|max:500'"
          :data-vv-as="translation(14943)"
        ></XVinput>
      </XVbootstraprow>
      <XVbootstraprow
        :label="translation(14946)"
        :required="true"
        :haserror="errors.has('rbAard')"
        :errormessage="errors.first('rbAard')"
      >
        <XVradiobuttonlist
          id="rbAard"
          v-model="aandeelhouder.rbAard"
          :datalist="[
            { value: 1, labelText: translation(14934) },
            { value: 2, labelText: translation(14933) },
          ]"
          v-validate="'required'"
          name="rbAard"
          :data-vv-as="translation(14946)"
          v-on:formvaluechanged="toggleAandeelhouderAard"
        ></XVradiobuttonlist>
      </XVbootstraprow>
      <div v-if="aandeelhouderRijksNrVerplicht">
        <XVbootstraprow
          :label="translation(14944)"
          :haserror="errors.has('tbxVoornaam')"
          :errormessage="errors.first('tbxVoornaam')"
        >
          <XVinput
            id="tbxVoornaam"
            name="tbxVoornaam"
            v-model="aandeelhouder.tbxVoornaam"
            type="text"
            v-validate="'max:100'"
            :data-vv-as="translation(14944)"
          ></XVinput>
        </XVbootstraprow>
        <XVbootstraprow
          :label="translation(14945)"
          :haserror="errors.has('tbxInitialen')"
          :errormessage="errors.first('tbxInitialen')"
        >
          <XVinput
            id="tbxInitialen"
            v-model="aandeelhouder.tbxInitialen"
            name="tbxInitialen"
            type="text"
            v-validate="'max:250'"
            :data-vv-as="translation(14945)"
          ></XVinput>
        </XVbootstraprow>
        <XVbootstraprow
          :label="translation(14984)"
          :required="aandeelhouderRijksNrVerplicht"
          :haserror="errors.has('tbxRijksregisternummer')"
          :errormessage="errors.first('tbxRijksregisternummer')"
        >
          <XVinput
            id="tbxRijksregisternummer"
            v-model="aandeelhouder.tbxRijksregisternummer"
            v-validate="rijksregNrVal"
            name="tbxRijksregisternummer"
            :data-vv-as="translation(14984)"
            v-on:formvaluechanged="rijksregNrOnChange"
          ></XVinput>
        </XVbootstraprow>
      </div>
      <XVbootstraprow
        v-if="aandeelhouderOndernNrVerplicht"
        :label="translation(14981)"
        :required="aandeelhouderOndernNrVerplicht"
        :haserror="errors.has('tbxOndernemingsnummer')"
        :errormessage="errors.first('tbxOndernemingsnummer')"
      >
        <XVinput
          id="tbxOndernemingsnummer"
          v-model="aandeelhouder.tbxOndernemingsnummer"
          v-validate="ondernemingsNrVal"
          name="tbxOndernemingsnummer"
          :data-vv-as="translation(14981)"
        ></XVinput>
      </XVbootstraprow>
      <XVbootstraprow
        :label="translation(14947)"
        :haserror="errors.has('tbxAandelen')"
        :errormessage="errors.first('tbxAandelen')"
        :required="true"
      >
        <XVinputnumber
          id="tbxAandelen"
          v-model="aandeelhouder.tbxAandelen"
          name="tbxAandelen"
          :data-vv-as="translation(14947)"
          v-validate="'required|decimal:2|max_value:100'"
        ></XVinputnumber>
      </XVbootstraprow>
      <XVbootstraprow
        :label="translation(14948)"
        :haserror="errors.has('tbxStemrecht')"
        :errormessage="errors.first('tbxStemrecht')"
        :required="true"
      >
        <XVinputnumber
          id="tbxStemrecht"
          v-model="aandeelhouder.tbxStemrecht"
          name="tbxStemrecht"
          :data-vv-as="translation(14948)"
          v-validate="'required|decimal:2|max_value:100'"
        ></XVinputnumber>
      </XVbootstraprow>
      <XVbootstraprow
        :label="translation(14949)"
        :required="true"
        :haserror="errors.has('tbxDatumActief')"
        :errormessage="errors.first('tbxDatumActief')"
      >
        <XVdate
          id="tbxDatumActief"
          name="tbxDatumActief"
          v-model.trim="aandeelhouder.iDatumactief"
          :data-vv-as="translation(14949)"
          v-validate="{ XVDateDefault: true, required: true }"
        ></XVdate>
      </XVbootstraprow>
      <XVbootstraprow
        :label="translation(14950)"
        :haserror="errors.has('tbxDatumInactief')"
        :errormessage="errors.first('tbxDatumInactief')"
      >
        <XVdate
          id="tbxDatumInactief"
          name="tbxDatumInactief"
          v-model.trim="aandeelhouder.iDatumInactief"
          :data-vv-as="translation(14950)"
          v-validate="{ XVDateDefault: true }"
        ></XVdate>
        <span class="form-group__message">{{ errors.first('tbxDatumInactief') }}</span>
      </XVbootstraprow>
      <XVbootstraprow :label="translation(14951)">
        <XVtextarea id="tbaOpmerking" v-model="aandeelhouder.tbaOpmerking" name="tbaOpmerking"></XVtextarea>
      </XVbootstraprow>
      <XVbootstraprow
        key="uploadNameRow"
        :label="translation(14952)"
        :required="true"
        :haserror="errors.has('uploadName')"
        :errormessage="errors.first('uploadName')"
      >
        <XVupload
          v-validate="'required|minuploads:1'"
          maximumfilecount="1"
          name="uploadName"
          :data-vv-as="translation(14952)"
          v-model="aandeelhouder.uploadfiles"
        ></XVupload>
      </XVbootstraprow>
    </fieldset>
  </div>
</template>

<script>
import { FAMixin, util } from 'pevueglobal'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { sync } from 'vuex-pathify'
import XVupload from '@/components/XVupload'
import Vue from 'vue'
export default {
  mixins: [FAMixin],
  components: {
    XVupload,
  },
  data: function () {
    return {}
  },

  async created() {
    if (this.aandeelhoudersTable.tablecolumnsetting.length === 0) {
      if (this.$route.params.personid) {
        this.$router.push({ name: 'VMSWaandeelhoudersInzien', params: { personid: this.$route.params.personid } })
      } else {
        this.$router.push({ name: 'VMSWaandeelhouders' })
      }
    } else {
      if (this.$route.params.aandeelhouderid) {
        await this.makeUpdateAandeelhouderDetail(this.$route.params.aandeelhouderid)
      }
    }
    this.stopLoading()
  },
  computed: {
    ...mapGetters('VMSWbestuurdersAandeelhouders', [
      'aandeelhoudersTable',
      'aandeelhouderRijksNrVerplicht',
      'aandeelhouderOndernNrVerplicht',
    ]),
    aandeelhouder: sync('VMSWbestuurdersAandeelhouders/aandeelhouder'),
    rijksregNrVal: function () {
      if (this.aandeelhouder.rbAard === 1) {
        return 'required: true|max:50|IsRRNoValid'
      } else {
        return 'max:50|IsRRNoValid'
      }
    },
    ondernemingsNrVal: function () {
      if (this.aandeelhouder.rbAard === 2) {
        return 'required: true|max:50'
      } else {
        return 'max:50'
      }
    },
  },
  methods: {
    ...mapActions('VMSWbestuurdersAandeelhouders', ['insertAandeelhouder', 'updateAandeelhouder']),
    ...mapMutations('VMSWbestuurdersAandeelhouders', ['makeUpdateAandeelhouderDetail', 'toggleAandeelhouderAard']),
    ...mapMutations(['addNotification']),
    btnTerug: function () {
      if (this.$route.params.personid) {
        this.$router.push({ name: 'VMSWaandeelhoudersInzien' })
      } else {
        this.$router.push({ name: 'VMSWaandeelhouders' })
      }
    },
    btnOpslaan: function () {
      this.$validator.validate().then((result) => {
        if (result) {
          let opmerking = this.aandeelhouder.tbaOpmerking
          if (this.aandeelhouder.tbaOpmerking === '') {
            opmerking = null
          }
          let aandeelhouderData = {
            tblVMSWAandeelhouderNaam: this.aandeelhouder.tbxNaam,
            tblVMSWAandeelhouderVoornaam: this.aandeelhouder.tbxVoornaam,
            tblVMSWAandeelhouderAndereVoornamen: this.aandeelhouder.tbxInitialen,
            tblVMSWAandeelhouderAandelenPercentage: this.aandeelhouder.tbxAandelen,
            tblVMSWAandeelhouderStemrechtPercentage: this.aandeelhouder.tbxStemrecht,
            tblVMSWAandeelhouderAard: this.aandeelhouder.rbAard,
            tblVMSWAandeelhouderDatumActief: util.DateForDatabase(this.aandeelhouder.iDatumactief),
            tblVMSWAandeelhouderDatumInactief: util.DateForDatabase(this.aandeelhouder.iDatumInactief),
            tblVMSWAandeelhouderOpmerking: opmerking,
            tblVMSWAandeelhouderVerklaringFMSA: this.aandeelhouder.uploadfiles[0].uploadFileID,
            tblVMSWAandeelhouderRijksregisterNummer: this.aandeelhouder.tbxRijksregisternummer,
            tblVMSWAandeelhouderOndernemingsnummer: this.aandeelhouder.tbxOndernemingsnummer,
          }
          if (this.$route.params.personid) {
            Vue.set(aandeelhouderData, 'tblpersonid', parseInt(this.$route.params.personid))
          }
          this.insertAandeelhouder(aandeelhouderData)
        } else {
          this.addNotification({
            groupname: 'warning',
            message: this.translation(14642),
          })
        }
      })
    },
    btnOpslaanUpdate: function () {
      this.$validator.validate().then((result) => {
        if (result) {
          let opmerking = this.aandeelhouder.tbaOpmerking
          if (this.aandeelhouder.tbaOpmerking === '') {
            opmerking = null
          }
          let aandeelhouderUpdateData = {
            tblVMSWAandeelhouderID: this.$route.params.aandeelhouderid,
            tblVMSWAandeelhouderNaam: this.aandeelhouder.tbxNaam,
            tblVMSWAandeelhouderVoornaam: this.aandeelhouder.tbxVoornaam,
            tblVMSWAandeelhouderAndereVoornamen: this.aandeelhouder.tbxInitialen,
            tblVMSWAandeelhouderAandelenPercentage: this.aandeelhouder.tbxAandelen,
            tblVMSWAandeelhouderStemrechtPercentage: this.aandeelhouder.tbxStemrecht,
            tblVMSWAandeelhouderAard: this.aandeelhouder.rbAard,
            tblVMSWAandeelhouderDatumActief: util.DateForDatabase(this.aandeelhouder.iDatumactief),
            tblVMSWAandeelhouderDatumInactief: util.DateForDatabase(this.aandeelhouder.iDatumInactief),
            tblVMSWAandeelhouderOpmerking: opmerking,
            tblVMSWAandeelhouderVerklaringFMSA: this.aandeelhouder.uploadfiles[0].uploadFileID,
            tblVMSWAandeelhouderRijksregisterNummer: this.aandeelhouder.tbxRijksregisternummer,
            tblVMSWAandeelhouderOndernemingsnummer: this.aandeelhouder.tbxOndernemingsnummer,
          }
          if (this.$route.params.personid) {
            Vue.set(aandeelhouderUpdateData, 'tblpersonid', parseInt(this.$route.params.personid))
          }
          this.updateAandeelhouder(aandeelhouderUpdateData)
        } else {
          this.addNotification({
            groupname: 'warning',
            message: this.translation(14642),
          })
        }
      })
    },
    rijksregNrOnChange: function () {
      this.aandeelhouder.tbxRijksregisternummer = this.aandeelhouder.tbxRijksregisternummer.replace(/ /g, '')
    },
  },
}
</script>
